import { resolveIcon } from '../../styles/icons'
import { useState } from "react"
import useTranslation from "../../hooks/useTranslation"
import styled from "styled-components"
import { Button } from "../generic/Core"
import ModalForm from "../modal/ModalForm"
import resolveModalForm from "../../utils/model/resolveModalForm"
import { useStore } from "../pageView/Page"
import { evaluateCondition } from "../../../../common/model/condition/evaluate"

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
`

const Count = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    margin-left: 0.5rem;
    padding: 0.1rem 0.5rem;
    border-radius: 999px;
    font-size: var(--font-XS);
    background: rgba(255, 255, 255, 0.25);
`

/*
 * How many things the button opens, for a `count` config:
 *   arrays      fields holding a list — each item counts (attachments)
 *   condition   when it holds, one more (a generated document)
 */
const countOf = (count, record) => {
    if (!count || !record) return 0
    const fromArrays = (count.arrays ?? [])
        .reduce((n, field) => n + (Array.isArray(record[field]) ? record[field].length : 0), 0)
    const fromCondition = count.condition && evaluateCondition(count.condition, { values: record }) ? 1 : 0
    return fromArrays + fromCondition
}

const MobileFormSection = styled.div`
    position: relative;
    max-width: ${({ width }) => width};
    padding:  1rem;
    border: 1px solid ${({ theme }) => theme.form.border};
    border-radius: 1rem;
    margin-bottom: 1rem;
    background: ${({ theme }) => theme.form.background};
    min-height: 3rem;    
    box-shadow: ${({ theme }) => theme.card.boxShadow};

    &:hover {
        border: 1px solid ${({ theme }) => theme.form.activeBorder};
    }
    
    @media (min-width: ${({ theme }) => theme.breakpoint.s}) {
        display: none;
    }

`




const MobileActionButton = ({ config, validated }) => {
    const [showModal, setShowModal] = useState(false)
    const { t } = useTranslation()
    const [record] = useStore(s => s)
    // Shown only when there is something: the button says the record has
    // documents before anyone opens it.
    const count = countOf(config.count, record)

    const openModal = () => {
        setShowModal(true)
    }

    // Through resolveModalForm, not `config.modalForm` — a section may declare its
    // form in place or name one with `modalFormRef`, and reading the property raw
    // sees only the first. Twelve identical document previews became a shared ref
    // on 2026-08-17, and this was the one caller that could not follow them.
    const modalForm = resolveModalForm(config)

    return (
        <MobileFormSection name="mobileActionButton">
            <ButtonWrapper>
                <Button width={'100%'} $variant='primary' onClick={openModal} data-testid={config.id ? `${config.entity}.mobile.${config.id}` : undefined}>
                    {t(config.title)}
                    {count > 0 && <Count>{resolveIcon(config.icon)}{count}</Count>}
                </Button>
            </ButtonWrapper>
            {showModal && <ModalForm
                isVisible={showModal}
                setIsVisible={setShowModal}
                modalTitle={config.modalTitle ? t(config.modalTitle) : 'Options'}
                id={modalForm.id}
                groups={modalForm.elements}
                //validated={validated}
                sectionName={'TBD'}
                mode='fullscreen'
                entity={config.entity}
                useStore={useStore}
            >
            </ModalForm>}

        </MobileFormSection>
    )

}

export default MobileActionButton